// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__wzvME","topBottomGutter":"Layout_topBottomGutter__1FVKX"};